import { MarketingCampaignType, Offer } from '../1_types/genericTypes';

export const isBngmOffer = (offer: Offer): boolean =>
  offer?.type === MarketingCampaignType.BUY_N_GET_M_CHEAPEST_AT_DISCOUNT;
